import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faComments, faUser } from '@fortawesome/free-regular-svg-icons';
import Routes from '../../../../../../resources/routes.json';

import { formatTaxId } from '../../../../utils/helper/formatting';
import { getBankByCode } from '../../../../utils/enumerator/enum-bank-code';
import { CookieHelper } from '../../../../utils/helper/cookie-helper';
import { COLLECTION } from '../../../../utils/enumerator/enum-loan-phase';

import { showFooter, showMenu } from '../../../../store/actions/util-actions';
import { logout } from '../../../../store/actions/auth-actions';

import { HandMoney, MenuIcon, Phone, MessageIcon, DoubtIcon, LeaveIcon, ShopIcon, InsuranceIcon } from '../icons';

import './index.scss';
import * as LoanState from '../../../../utils/enumerator/enum-loan-state';
import useInsurance from '../../../../hooks/useInsurance';

function CustomerMenuItem({ text, icon, onClick, isNew = false }) {
  return (
    <li className="customer-menu-item" onClick={onClick}>
      <span className="customer-menu-item-icon">{icon}</span>
      <span className="customer-menu-item-text">
        {isNew && <button className="is-new">Novo!</button>}
        {text}
      </span>
      <span className="customer-menu-item-arrow">
        <FontAwesomeIcon icon={faChevronRight} />
      </span>
    </li>
  );
}

function CustomerMenuComponent(props) {
  const { currentLoan } = props;
  const loanPhaseId = currentLoan?.state?.phase?.id;
  const [opened, setOpened] = useState(false);

  const loanStateId = currentLoan.state?.id;

  const showInsuranceMenu =
    loanStateId && ![LoanState.ON_TIME_FULLY_PAID_OFF, LoanState.LATE_FULLY_PAID_OFF].includes(loanStateId);

  const toggleOpened = () => {
    setOpened(!opened);
  };

  useEffect(() => {
    if (opened) {
      // Set overflow to hidden on body.
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
      // Remove overflow hidden from body.
      document.getElementsByTagName('body')[0].removeAttribute('style');
    }
  }, [opened]);

  const bank = getBankByCode(currentLoan?.application?.financial?.bankAccount?.bankCode);

  const logout = () => {
    localStorage.removeItem('loggedIn');
    CookieHelper.remove('SESSION');
    sessionStorage.clear();
    props.showMenu(true);
    props.showFooter(true);
    props.logout();
    document.location.reload();
  };

  return (
    <>
      {!opened ? (
        <div className="menu-icon">
          <MenuIcon onClick={toggleOpened} />
        </div>
      ) : (
        <div className="customer-menu">
          <div className="customer-menu-close-button" onClick={toggleOpened}>
            <button>
              <FontAwesomeIcon icon={faTimes} size="2x" />
            </button>
          </div>
          <div className="customer-menu-header">
            <div className="customer-menu-header-customer">
              <div className="customer-menu-header-customer-icon">
                <FontAwesomeIcon icon={faUser} />
              </div>
              <div className="customer-menu-header-customer-name">
                {currentLoan?.application?.personal?.name || '---'}
              </div>
            </div>
            <div className="customer-menu-header-tax-id">
              CPF: {formatTaxId(currentLoan?.application?.personal?.taxId) || '---'}
            </div>
            <div className="customer-menu-header-bank-account">
              Ag.: {currentLoan?.application?.financial?.bankAccount?.branchNumber || '---'}
              &bull; Conta: {currentLoan?.application?.financial?.bankAccount?.number || '####'}-
              {currentLoan?.application?.financial?.bankAccount?.checkDigit || '#'}
              &bull;
              {bank?.name || '---'} ({bank?.code || '---'})
            </div>
            {false && (
              <div className="customer-menu-header-data-button">
                <button>Meus dados</button>
              </div>
            )}
          </div>
          <div className="customer-menu-body">
            <ul className="customer-menu-items">
              <NavLink to={Routes.CUSTOMER_LOAN_PAGE.DEFAULT}>
                <CustomerMenuItem text="Meu empréstimo" icon={<HandMoney />} onClick={() => toggleOpened()} />
              </NavLink>

              {/* hide if loan installment late */}
              {/* {loanPhaseId !== COLLECTION && (
                <NavLink to={Routes.CUSTOMER_SHOP_PAGE.DEFAULT}>
                  <CustomerMenuItem
                    text="SuperSim Shop"
                    icon={<ShopIcon fill="red" />}
                    onClick={() => toggleOpened()}
                    isNew
                  />
                </NavLink>
              )} */}

              {/* Redirect to landing in site */}
              {showInsuranceMenu && (
                <NavLink to={Routes.CUSTOMER_INSURANCE_PAGE.DEFAULT}>
                  <CustomerMenuItem
                    text="Conheça o SuperSeguro"
                    icon={<InsuranceIcon />}
                    onClick={() => toggleOpened()}
                    isNew
                  />
                </NavLink>
              )}

              <NavLink to={Routes.MESSAGE_PREFERENCE.DEFAULT}>
                <CustomerMenuItem
                  text="Preferências de mensagens"
                  icon={<MessageIcon />}
                  onClick={() => toggleOpened()}
                />
              </NavLink>

              {/* <NavLink to={Routes.CUSTOMER_LOAN_MULTIPLIK_PAGE.DEFAULT}>
              <CustomerMenuItem
                text="Programa Multiplik"
                icon={<Tickets />}
                onClick={() => toggleOpened()}
                isNew={true}
              />
            </NavLink> */}

              <a href="https://www.supersim.com.br/como-solicitar-emprestimo" target="_blank">
                <CustomerMenuItem text="Dúvidas frequentes" icon={<DoubtIcon />} />
              </a>

              {false && (
                <CustomerMenuItem
                  text="Chat atendimento"
                  icon={<FontAwesomeIcon icon={faComments} />}
                  onClick={() => toggleOpened()}
                />
              )}

              <a href="tel:+551140039528">
                <CustomerMenuItem text="Ligar para SuperSim" icon={<Phone />} onClick={() => toggleOpened()} />
              </a>

              <NavLink to="/">
                <CustomerMenuItem text="Sair" icon={<LeaveIcon />} onClick={logout} />
              </NavLink>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  currentLoan: state.personalLending.loan,
});

const mapDispatchToProps = (dispatch) => ({
  showFooter: (show) => dispatch(showFooter(show)),
  showMenu: (show) => dispatch(showMenu(show)),
  logout: () => dispatch(logout()),
});

const CustomerMenu = connect(mapStateToProps, mapDispatchToProps)(CustomerMenuComponent);

export { CustomerMenu };
